import { MAP_LAYER } from 'components/Map/constants';

export const FLIGHT_PATH_LAYERS = [
    MAP_LAYER.FLIGHT_PATH_LINE,
    MAP_LAYER.FLIGHT_PATH_FILL,
    MAP_LAYER.FLIGHT_PATH_HIGHLIGHT_LINE,
    MAP_LAYER.FLIGHT_PATH_HIGHLIGHT_FILL
];

export const BOUNDARY_LAYERS = [
    MAP_LAYER.STATIC_BOUNDARY_FILL,
    MAP_LAYER.STATIC_BOUNDARY_OUTLINE,
    MAP_LAYER.STATIC_OBSTACLE_FILL,
    MAP_LAYER.STATIC_BOUNDING_BOX_OUTLINE,
    MAP_LAYER.STATIC_OBSTACLE_BOUNDING_BOX_OUTLINE,
    MAP_LAYER.CLUSTER,
    MAP_LAYER.CLUSTER_COUNT,
    MAP_LAYER.UNCLUSTERED_POINT,
    MAP_LAYER.UNCLUSTERED_COUNT
];
